module.exports = __webpack_public_path__ + "img/bbl_i3.10d94ec1.png";